// API Configuration
// For Cloud Run deployment, frontend and backend are served from same origin
// Use empty string for relative URLs in production, localhost for development
const getDefaultApiUrl = () => {
  if (typeof window !== 'undefined') {
    // In production (Cloud Run), use relative URLs (same origin)
    if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
      return '';  // Relative URLs for production
    }
    // In development, use localhost backend
    return 'http://localhost:8001';
  }
  return 'http://localhost:8001';
};

const API_BASE_URL = process.env.REACT_APP_API_URL ?? getDefaultApiUrl();

// Helper function for dynamic URLs
export const getApiUrl = (path) => API_BASE_URL + path;

// Export BASE_URL for direct use
export const BASE_URL = API_BASE_URL;

// Authenticated fetch wrapper - automatically includes JWT token
export const apiFetch = async (url, options = {}) => {
  const token = localStorage.getItem('token');

  const defaultHeaders = {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  const response = await fetch(url, config);

  // Handle 401 Unauthorized - redirect to login
  if (response.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
    throw new Error('Unauthorized - redirecting to login');
  }

  return response;
};

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  ENDPOINTS: {
    // Authentication
    LOGIN: `${API_BASE_URL}/auth/login`,
    LOGOUT: `${API_BASE_URL}/auth/logout`,
    VERIFY_TOKEN: `${API_BASE_URL}/auth/verify`,

    // Core API
    CUSTOMERS: `${API_BASE_URL}/api/customers`,
    PRODUCTS: `${API_BASE_URL}/api/products`,
    QUOTATIONS: `${API_BASE_URL}/api/quotes`,
    SALES_ORDERS: `${API_BASE_URL}/api/sales-orders`,
    PRODUCTION_ORDERS: `${API_BASE_URL}/api/production/orders`,
    PURCHASE_ORDERS: `${API_BASE_URL}/api/purchase-orders`,
    INVENTORY: `${API_BASE_URL}/api/inventory`,
    BOMS: `${API_BASE_URL}/api/boms`,
    MACHINES: `${API_BASE_URL}/api/machines`,
    USERS: `${API_BASE_URL}/api/users/`,
    DASHBOARD: `${API_BASE_URL}/api/dashboard`,
    SKILLS: `${API_BASE_URL}/api/skills/`,
    DEPARTMENTS: `${API_BASE_URL}/api/departments/`,
    SUPPLIERS: `${API_BASE_URL}/api/suppliers`,
    PROCESSES: `${API_BASE_URL}/api/processes`,
    WORKFLOWS: `${API_BASE_URL}/api/workflows/`,
    TASKS: `${API_BASE_URL}/api/tasks`,
    PRODUCTION_TASKS: `${API_BASE_URL}/api/production-tasks`,
    PRODUCT_TYPES: `${API_BASE_URL}/api/product-types/`,

    // Notifications
    NOTIFICATIONS: `${API_BASE_URL}/api/notifications`,

    // Quality Control
    QC: `${API_BASE_URL}/api/qc`,

    // Data Exports
    EXPORTS: `${API_BASE_URL}/api/exports`,

    // Formulations
    FORMULATIONS: `${API_BASE_URL}/api/formulations`,

    // AI
    CHAT: `${API_BASE_URL}/api/chat`,
    CHAT_STREAM: `${API_BASE_URL}/api/chat/stream`,
    CHAT_CONVERSATIONS: `${API_BASE_URL}/api/chat/conversations`,
    AI_COSTS: `${API_BASE_URL}/api/ai/costs`,
  }
};

export default API_CONFIG;